<template>
  <section class="resume-section" id="about">
    <div class="resume-section-content" v-if="profile.isLoading">
      <ListLoader />
    </div>

    <div class="resume-section-content" v-else>
      <h1 class="mb-0">
        {{ profile.firstName }}
        <span class="text-primary">{{ profile.lastName }}</span>
      </h1>
      <div class="subheading mb-5">
        {{ profile.address.street }} · {{ profile.address.province }},
        {{ profile.address.country }} · {{ profile.phone }} ·
        <a :href="`mailto:${profile.email}`">{{ profile.email }}</a>
      </div>
      <p class="lead mb-5">
        {{ profile.bio }}
      </p>

      <!-- Social Media -->
      <div class="social-icons">
        <a
          class="social-icon"
          v-for="item in socialMedia"
          :key="item.id"
          :href="`${item.url}`"
          target="_blank"
          ><i :class="`${item.icon}`"></i
        ></a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ListLoader } from "vue-content-loader";

export default {
  components: { ListLoader },
  computed: mapGetters(["profile", "socialMedia"]),
  methods: mapActions(["fetchProfile", "fetchSocialMedia"]),
  created() {
    this.fetchProfile();
    this.fetchSocialMedia();
  },
};
</script>
